import React from 'react'

const AboutUsPage = () => {
    return (
        <div>

        </div>
    )
}

export default AboutUsPage
